import React, { useEffect } from 'react';
import { RegistrationCustomersPageStyled } from './registration-customers.styled';
import Form from '../../../../components/shared/form/form';
import RegistrationCustomersForm from './components/registration-customers-form';
import i18n from '../../../../translations/strings';
import {
  ValidationRegistrationCustomerSchema,
  ValidationRegistrationSocialSchema,
} from './components/constants';
import {
  completeRegistrationAction,
  registrationCustomerAction,
  registrationPartialResetState,
  registrationResetState,
} from '../../../../store/auth/registration.store';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { makeReservationResetState } from '../../../../store/shared/make-reservation.store';
import { userResetState } from '../../../../store/user.store';
import { useModal } from '../../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../../components/shared/modal-provider/components/modal/modal.constants';
import { SvgImage, SvgType } from '../../../../components/base/svg/svg';

const RegistrationCustomersPage = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { openModal } = useModal();

  const params = useParams();
  const finalize = params?.id;

  const {
    registrationSuccess,
    loading,
    error,
    temporaryBookingDataFromLanding,
    completeRegistration,
  } = useSelector((state: any) => {
    return state.registration;
  });

  const { user } = useSelector((state: any) => {
    return state.user;
  });

  const handleCloseModal = () => {
    dispatch(registrationPartialResetState());
  };

  useEffect(() => {
    if (finalize) {
      if (completeRegistration) {
        openModal({
          message: i18n.t('registration.registrationConfirmed'),
          variant: ModalVariant.Success,
          handleCloseModal: () => navigate('/login'),
        });
      }
    }
  }, [completeRegistration]);

  useEffect(() => {
    if (finalize) {
      dispatch(completeRegistrationAction(finalize));
    }
  }, []);

  useEffect(() => {
    if (registrationSuccess) {
      openModal({
        message: i18n.t('registration.registrationSuccess'),
        variant: ModalVariant.Success,
        handleCloseModal: () => {
          dispatch(registrationResetState());
          dispatch(userResetState());
          dispatch(makeReservationResetState());
          navigate('/login');
        },
      });
    }
  }, [registrationSuccess]);

  useEffect(() => {
    openModal({
      message: error,
      variant: ModalVariant.Error,
      handleCloseModal: handleCloseModal,
    });
  }, [error]);

  const onSubmit = (data: any) => {
    delete data.privacy;

    if (state?.isSocialRegistration) {
      if (state?.provider === 'google') {
        data.google_id = user.google_id;
        data.access_token = user.access_token;
      } else if (state?.provider === 'facebook') {
        data.facebook_id = user.facebook_id;
        data.access_token = user.access_token;
      }
    }

    if (state?.isBookingFromLandingPage && temporaryBookingDataFromLanding) {
      let bookingData = {
        interval: temporaryBookingDataFromLanding.customerEvents,
        notes: temporaryBookingDataFromLanding.notes,
      };
      data.booking = bookingData;
    }
    dispatch(registrationCustomerAction(data));
  };

  return (
    <RegistrationCustomersPageStyled.Container container>
      <RegistrationCustomersPageStyled.ContainerForm item md={5} xs={12}>
        <RegistrationCustomersPageStyled.ContainerLogo>
          <SvgImage type={SvgType.LogoCsv} />
        </RegistrationCustomersPageStyled.ContainerLogo>
        <RegistrationCustomersPageStyled.Separator />
        {finalize ? (
          <RegistrationCustomersPageStyled.TextSocial>
            {i18n.t('registration.registrationComplete')}
          </RegistrationCustomersPageStyled.TextSocial>
        ) : (
          <RegistrationCustomersPageStyled.TextSocial>
            {state?.isBookingFromLandingPage && temporaryBookingDataFromLanding
              ? i18n.t('registration.registrationWithBookingTitle')
              : i18n.t('registration.completeSignUp')}
          </RegistrationCustomersPageStyled.TextSocial>
        )}
        <RegistrationCustomersPageStyled.Separator />
        {!finalize && (
          <Form
            schema={
              state?.isSocialRegistration
                ? ValidationRegistrationSocialSchema
                : ValidationRegistrationCustomerSchema
            }
          >
            <RegistrationCustomersForm onSubmit={onSubmit} loading={loading} />
          </Form>
        )}
      </RegistrationCustomersPageStyled.ContainerForm>
    </RegistrationCustomersPageStyled.Container>
  );
};

export default RegistrationCustomersPage;
